import { Block } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
export default function onEnter(event, editor, next) {
  editor.command('removeCurrentMarks');
  var startBlock = editor.value.startBlock;
  var isVoidBlock = editor.isVoid(startBlock);
  var isAtStartOfBlock = editor.isAtStartOfBlock();

  if (isAtStartOfBlock && (!editor.isDefaultBlock() || editor.isIndented()) && editor.isEmptyBlock() && !isVoidBlock) {
    event.preventDefault();
    return editor.resetBlocks();
  }

  if (isAtStartOfBlock && editor.isHeaderBlock()) {
    event.preventDefault();
    var path = editor.value.document.getPath(editor.value.startBlock.key);
    var node = Block.create({
      type: BlockTypes.UNSTYLED
    });
    return editor.insertNodeByPath(path.butLast(), path.last(), node);
  }

  if (isVoidBlock || !editor.isContinuousBlock() && editor.value.selection.start.offset > 0) {
    event.preventDefault();
    return editor.splitBlock().resetBlocks().setBlocks({
      data: {
        depth: startBlock.getIn(['data', 'depth'])
      }
    });
  }

  return next();
}